export const showToastQueryParam = 'show-toast';
export const showDialogQueryParam = 'show-dialog';
export const dialogOpened = 'dialog';
